import React from "react";
import { Categoria } from "../../utils/types";
import { Users, Trophy, Calendar } from "lucide-react";

interface Props {
  categoria: Categoria;
  jugadoresCount?: number;
  torneosCount?: number;
  onClick?: () => void;
}

export default function CategoriaCard({ categoria, jugadoresCount, torneosCount, onClick }: Props) {
  const estadoColor = categoria.estado === "activa" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500";

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          {categoria.color_hex && (
            <div
              className="w-8 h-8 rounded-lg flex-shrink-0"
              style={{ backgroundColor: categoria.color_hex }}
            />
          )}
          <div>
            <h3 className="font-bold text-gray-900 text-lg">{categoria.nombre}</h3>
            {categoria.anio_nacimiento && (
              <p className="text-xs text-gray-500">Año: {categoria.anio_nacimiento}</p>
            )}
          </div>
        </div>
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${estadoColor}`}>
          {categoria.estado}
        </span>
      </div>

      <div className="flex items-center gap-4 text-sm text-gray-500 mt-2">
        <span className="flex items-center gap-1">
          <Users className="w-4 h-4" />
          {jugadoresCount ?? "—"} jugadores
        </span>
        <span className="flex items-center gap-1">
          <Trophy className="w-4 h-4" />
          {torneosCount ?? "—"} torneos
        </span>
        <span className="ml-auto text-xs text-gray-400 capitalize">{categoria.genero}</span>
      </div>
    </div>
  );
}
